import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getContactList(params) {
  return request({
    url: URL.partner.contact,
    method: 'get',
    params
  })
}

export function queryContactPageableFast(data) {
  return request({
    url: URL.partner.queryContactPageableFast,
    method: 'post',
    data
  })
}

export function saveContact(data) {
  return request({
    url: URL.partner.contact,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delContact(uuid) {
  return request({
    url: URL.partner.contact + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function activeB2BAccountAuth(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.partner.activeB2BAccountAuth,
    method: 'post',
    data
  })
}

export function activeB2BAccountCompany(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.partner.activeB2BAccountAuth,
    method: 'post',
    data
  })
}

export function resetB2BUserPassword(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.partner.resetB2BUserPassword,
    method: 'post',
    data
  })
}

export function getContacts(params) {
  return request({
    url: URL.partner.getContacts,
    method: 'get',
    params
  })
}

export function queryContactsByCmpIdx(cmpIdxList) {
  return request({
    url: URL.partner.queryContactsByCmpIdx,
    method: 'post',
    data: cmpIdxList
  })
}

export function queryEnterpriseWechatContact(data) {
  return request({
    url: URL.partner.queryEnterpriseWechatContact,
    method: 'post',
    data
  })
}

export function updateEnterpriseWechatContact(data) {
  return request({
    url: URL.partner.updateEnterpriseWechatContact,
    method: 'post',
    data
  })
}

export function saveVerificationCode(data) {
  return request({
    url: URL.partner.saveVerificationCodeUrl,
    method: 'post',
    data
  })
}

export function queryRpaAccounts(data) {
  return request({
    url: URL.partner.queryRpaAccountsUrl,
    method: 'post',
    data
  })
}

export function updateContactBookingAgent(data) {
  return request({
    url: URL.partner.updateContactBookingAgentUrl,
    method: 'post',
    data
  })
}
